import axios from 'axios';

export default {
  get: (params) => axios.get('/api/v1/avg/log-book', { params }),
  create: (params) => axios.post('/api/v1/avg/log-book', params),
};
